import React, {useState} from 'react';
import firebase from 'firebase/app';

//blueprint
import { 
    Button,
    EditableText, 
    Position,  
    Intent, 
    Toaster 
} from "@blueprintjs/core";

const AppToaster = Toaster.create({
    className: "edited-content",
    position: Position.TOP,
});

const showToast = () => {
    AppToaster.show({ message: "Message is edited", intent: Intent.SUCCESS, timeout: 1000});
}

const EditMsgForLiked = ({content, setOpen, profile, id, setSave}) => {

    const [ editedContent, setEditedContent ] = useState(content)

    const handleChange = (e) =>{
        setEditedContent(e)
    }

    const handleSave = () => {
        firebase
            .firestore()
            .collection('likedContent')
            .doc(id)
            .update({
                ProspectContent: editedContent
            })
            .then(()=>{
                showToast();
                setOpen(false);
                setSave(false)
            })
    }

    return (
        <div>
            <div>
                <EditableText
                style={{
                    padding: 0
                }}
                multiline={true}
                defaultValue={content}
                onChange={handleChange}
                />
            </div>
            <div className="mt-4">
                <Button 
                intent="primary"
                // style={{marginRight: 20, borderRadius: 5}}
                // large='true'
                icon='thumbs-up'
                onClick={()=>handleSave()}>
                    Approve Changes
                </Button>
            </div>
        </div>
    ) 
}

export default EditMsgForLiked
